import addWhite from './icons/White/Add.png';
import chatBlue from './icons/Blue/Chat.png';
import chatWhite from './icons/White/Chat.png';
import helpWhite from './icons/White/Help.png';
import duplicateGrey from './icons/Grey/Duplicate.png';
import pasteGrey from './icons/Grey/Paste.png';
import datepickerGrey from './icons/Grey/date_grey.png';
import editGrey from './icons/Edit.png';
import warningRed from './icons/Red/Warning.png';
import excelExport from './icons/ExcelExport.png';
import radioOnBlue from './icons/Blue/Radio_on.png';
import radioOffBlue from './icons/Blue/Radio_off.png';
import checkboxOnBlue from './icons/Blue/Checkbox on.png';
import checkboxOffBlue from './icons/Blue/Checkbox off.png';
import upArrow from './icons/UpArrow.png';
import downArrow from './icons/DownArrow.png';
import clock16 from './icons/Grey/Clock16.png';
import copy16 from './icons/Grey/Copy16.png';
import paste16 from './icons/Grey/Paste16.png';

const icons = {
  white: {
    add: addWhite,
    chat: chatWhite,
    help: helpWhite
  },
  grey: {
    edit: editGrey,
    duplicate: duplicateGrey,
    paste: pasteGrey,
    datepicker: datepickerGrey,
    clock16,
    copy16,
    paste16

  },
  blue: {
    chat: chatBlue,
    radio_on: radioOnBlue,
    radio_off: radioOffBlue,
    checkbox_on: checkboxOnBlue,
    checkbox_off: checkboxOffBlue
  },
  red: {
    warning: warningRed
  },
  excelExport,
  upArrow,
  downArrow
};

export default icons;



// WEBPACK FOOTER //
// ./src/assets/icons.js